import React, { useState, useRef, useEffect } from "react";
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import MegaMenu from "./MegaMenu";
import "../assets/css/global.css";

const AppNavbar = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [megaVisible, setMegaVisible] = useState(false);
  const location = useLocation();

  const timeoutRef = useRef(null);

  const handleClose = () => setShowMobileMenu(false);
  const handleShow = () => setShowMobileMenu(true);


  // ✅ OPEN MENU
  const openMenu = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setMegaVisible(true);
  };

  // ✅ CLOSE MENU WITH DELAY
  const closeMenu = () => {
    timeoutRef.current = setTimeout(() => {
      setMegaVisible(false);
    }, 150);
  };

  useEffect(() => {
    setMegaVisible(false);
  }, [location.pathname]);

  return (
    <>
      {/* Top Bar */}
      <div style={{ backgroundColor: "#242324", color: "white", padding: "5px 0", textAlign: "right" }}>
        <Container>
          <Nav className="justify-content-end">
            <Nav.Link href="/gallery" className="text-white">Gallery</Nav.Link>
            <Nav.Link href="/events" className="text-white">Events</Nav.Link>
            <Nav.Link href="/contact" className="text-white">Contact Us</Nav.Link>
          </Nav>
        </Container>
      </div>

      {/* Main Navbar */}
      <Navbar bg="white" expand="lg" className="shadow-sm" sticky="top">
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Biopharmacieaa" height="40" /> Biopharmacieaa
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" onClick={handleShow} />

          <Navbar.Collapse id="main-navbar" className="d-none d-lg-flex">
            <Nav className="ms-auto align-items-center">

              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/about">About Us</Nav.Link>

              {/* ✅ FIXED PRODUCTS HOVER */}
              <div
                onMouseEnter={openMenu}
                onMouseLeave={closeMenu}
              >
                <Nav.Link className="products-nav">Products</Nav.Link>
              </div>

              <Nav.Link href="/learning">Learnings</Nav.Link>
              <Nav.Link href="/blogs">Blog</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>

        {/* ✅ Desktop mega menu — hidden below lg breakpoint */}
        <div className="d-none d-lg-block">
          <MegaMenu
            visible={megaVisible}
            openMenu={openMenu}
            closeMenu={closeMenu}
          />
        </div>
      </Navbar>

      {/* Mobile Menu */}
      <Offcanvas show={showMobileMenu} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={logo} alt="Biopharmacieaa" height="30" /> Menu
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link href="/" onClick={handleClose}>Home</Nav.Link>
            <Nav.Link href="/about" onClick={handleClose}>About Us</Nav.Link>

            <MegaMenu variant="mobile" onLinkClick={handleClose} isDrawerOpen={showMobileMenu} />

            <Nav.Link href="/learning" onClick={handleClose}>Learnings</Nav.Link>
            <Nav.Link href="/blogs" onClick={handleClose}>Blog</Nav.Link>
            <Nav.Link href="/gallery" onClick={handleClose}>Gallery</Nav.Link>
            <Nav.Link href="/events" onClick={handleClose}>Events</Nav.Link>
            {/* <Nav.Link href="/jobs" onClick={handleClose}>Jobs</Nav.Link> */}
            <Nav.Link href="/contact" onClick={handleClose}>Contact Us</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AppNavbar;
